/// <reference no-default-lib="true"/>
/* eslint-disable */
import { useEffect, useState } from "react";
import { Box, Button, InputBase, MenuItem, TextField, Typography, DialogActions } from "@mui/material";
import { Card, Container, IconButton } from "@mui/material";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import api from "../../../services/api";
import Date from "../../../utils/date";
import HeaderSession from "../../../utils/headerSession";
import MessageSuccess from "../../../messages/messageSuccess";
import MessageError from "../../../messages/messageError";
import Createinformacao from "./createInformacao";
import { makeStyles } from '@material-ui/core'
import ButtonLeft from "../../../utils/buttonLeft";
import Paginacao from "../../../utils/paginacao";
import { useSearchParams } from "react-router-dom";
import DocEdit from "../../../utils/docEdit";
import Delete from "../../../utils/delete";
import LoadingSkeleton from "../../../load/loadingSkeleton";

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: 20,
        textAlign: 'justify',
        fontSize: 18,
        lineHeight: 1.5
    },
    title: {
        fontSize: 25,
        fontWeight: 'bold',
        paddingTop: 20,
        // textAlign: 'center',
        color: '#67348d'
    },
}))

export default function GestSite() {
    const classes = useStyles()
    const [siteInfos, setSiteInfos] = useState('')
    const [createInformacao, setCreateInformacao] = useState(false)
    const [editeInformacao, setEditeInformacao] = useState(false)
    const [message, setMessage] = useState('')
    const [messageError, seterrorMessage] = useState('')
    const [configLista, setConfigLista] = useState('')
    const [perPage, setPerPage] = useState(50)
    const [searchParams] = useSearchParams();
    const [page, setPage] = useState(searchParams.get("page") ?? 1);
    const [menu, setMenu] = useState(searchParams.get("menu") ?? false);
    const [editAnexo, setEditAnexo] = useState('');
    const [openDelete, setOpenDelete] = useState('');
    const [filter, setFilter] = useState('');
    const menuParams = searchParams.get("menu");


    useEffect(() => {
        setSiteInfos('')
        api.get(`/site-infos?menu=${menu === false ? '' : menu}&sortBy=createdAt:${menu ? 'DESC' : 'ASC'}&perPage=${perPage}&page=${page}`)
            .then(res => {
                // console.log(res)
                setSiteInfos(res.data.siteInfos);
                setFilter(res.data.siteInfos);
                setConfigLista(res.data);
            })
            .catch(() => {
            }).finally(() => {
                // setLoad(false);
            });
    }, [menu, page, perPage, editeInformacao, createInformacao])

    const HandleEdit = (informacao) => {
        setEditeInformacao(informacao)
    }


    const menus = ['INFORMAÇŌES', 'SOBRE NÓS', 'CONTROLO DE QUALIDADE', 'FARMACOVIGILÂNCIA', 'LEGISLACÃO E DOCUMENTOS', 'MEDICAMENTOS']

    // FILTRO DE INFORMACOES
    const filtraInformacoes = (valor) => {
        setSiteInfos(filter.filter((informacoes) => (informacoes?.titulo?.toLowerCase().includes(valor.toLowerCase()) || informacoes?.menu?.toLowerCase().includes(valor.toLowerCase()))))
    }

    return (
        <Container>
            <HeaderSession title={`GESTÃO DAS INFORMAÇÕES DO SITE ${menu ? '/ ' + menu : ''} `} />

            {message && <MessageSuccess message={message} />}
            {messageError && <MessageError message={messageError} />}

            <Card>
                {(!createInformacao && !editeInformacao) &&
                    <ButtonLeft title={'criar'} funcao={() => setCreateInformacao(!createInformacao)} >

                        <InputBase
                            style={{ width: '100%', border: '1px solid #85287e', borderRadius: 5, paddingLeft: 20 }}
                            sx={{ ml: 1, flex: 1 }}
                            autoFocus
                            placeholder="Filtra aquí as informações"
                            inputProps={{ 'aria-label': 'Filtrar lista' }}
                            onChange={(e) => { filtraInformacoes(e.target.value) }}
                        />

                        <TextField
                            style={{ minWidth: 200, margin: 4 }}
                            select
                            disabled={menuParams}
                            size="small"
                            variant="outlined"
                            onChange={(e) => setMenu(e.target.value === false ? "" : e.target.value)}
                            defaultValue={menu ?? 'Geral'}
                        >
                            <MenuItem value={false}>Geral</MenuItem>
                            {menus?.map((menu) => (
                                <MenuItem key={menu} value={menu}>
                                    {menu}
                                </MenuItem>
                            ))}
                        </TextField>

                    </ButtonLeft>
                }

                {createInformacao &&
                    <Createinformacao
                        menus={menus}
                        informacao={''}
                        setCreateInformacao={setCreateInformacao}
                        setMessage={setMessage}
                        seterrorMessage={seterrorMessage}
                    />
                }

                {editeInformacao &&
                    <Createinformacao
                        menus={menus}
                        informacao={editeInformacao}
                        setCreateInformacao={setEditeInformacao}
                        setMessage={setMessage}
                        seterrorMessage={seterrorMessage}
                    />
                }

                {(siteInfos && !createInformacao && !editeInformacao) &&
                    <>
                        {siteInfos.map((info) => (
                            <Box key={info._id} sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 2, position: 'relative' }}>


                                <IconButton title='Editar' style={{ position: 'absolute', right: 50, top: 0 }} onClick={() => HandleEdit(info)} color="error"> <ModeEditIcon color='secondary' /></IconButton>
                                <Delete
                                    open={openDelete === info._id ? true : false}
                                    button={true}
                                    setOpen={setOpenDelete}
                                    url={'/site-info/delete'}
                                    msg={`Tem certeza que deseja deletar ${info?.titulo}`}
                                    id={info._id}
                                />


                                <h1 className={classes.title}>
                                    {info?.menu?.toUpperCase()} {info?.titulo ? ' / ' + info?.titulo?.toUpperCase() : ''}
                                </h1>

                                <Typography variant="body1" style={{ lineHeight: 1, fontSize: 10 }}>
                                    Data: <Date date={info.createdAt} />
                                    <br />
                                    Ultima actualização: <Date date={info.updatedAt} />
                                </Typography>

                                <div className={classes.root} style={{ lineHeight: 1.5 }} dangerouslySetInnerHTML={{ __html: info?.conteudo }} />

                                {info?.anexo ? (
                                    info?.anexo.includes("png") ?
                                        <>
                                            <img width={800} style={{ width: '100%', objectFit: 'cover', }} src={info?.anexo} alt="" />

                                            <DialogActions>
                                                <Button onClick={() => setEditAnexo(editAnexo ? '' : info._id)}>Editar Imagem</Button>
                                            </DialogActions>
                                        </>
                                        :
                                        <>
                                            <ButtonLeft
                                                funcao={() => window.open(info.anexo, "_blank", "noopener,noreferrer")}
                                                title={'Ver anexo'} >
                                                <Button onClick={() => setEditAnexo(editAnexo ? '' : info._id)}>Editar Doc</Button>
                                            </ButtonLeft>
                                        </>)
                                    :
                                    <>
                                        {/* PARA CASO NAO EXISTA ANEXO  */}
                                        <DialogActions>
                                            <Button onClick={() => setEditAnexo(editAnexo ? '' : info._id)}>Adicionar Anexo</Button>
                                        </DialogActions>
                                    </>

                                }
                                {/* EDICAO DO ANEXO */}
                                {editAnexo === info._id && <DocEdit anexo={true} id={info._id} nomeDoc={'anexo'} label={'Editar o documento anexado'} url={'/site-info/change-anexo'} />}
                            </Box>
                        ))}

                        <Card >
                            <Paginacao
                                configLista={configLista}
                                lista={siteInfos}
                                page={page}
                                setPage={setPage}
                                setPerPage={setPerPage}
                            />
                        </Card>
                    </>
                }

                {!siteInfos && <LoadingSkeleton />}

            </Card>
        </Container>
    )
}